export default __webpack_public_path__ + "static/media/baby-13.40e06fcc.svg";